module.exports = __webpack_public_path__ + "img/discard_silo_full.f39ec4da.jpeg";